/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.searchStarterPacksSkeleton'

export { $nsid }

/** Backend Starter Pack search, returns only skeleton. */
const main = l.query(
  $nsid,
  l.params({
    q: l.string(),
    viewer: l.optional(l.string({ format: 'did' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 25),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    hitsTotal: l.optional(l.integer()),
    starterPacks: l.array(
      l.ref<UnspeccedDefs.SkeletonSearchStarterPack>(
        (() => UnspeccedDefs.skeletonSearchStarterPack) as any,
      ),
    ),
  }),
  ['BadQueryString'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
